import 'date-fns';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import TextField from "@material-ui/core/TextField";

export default function MaterialUIPickers(props) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container  style={{ width: '70%', margin: '0.1%' }}>
        <Grid item xs={12} sm={4}>
          <KeyboardDatePicker
            allowKeyboardControl
            variant="inline"
            autoOk
            disabled
            margin='dense'
            id="date-picker-inline"
            format="dd/MM/yyyy"
            label="Από"
            value={props.initialDate}
            invalidLabel="hcue"
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <KeyboardDatePicker
            allowKeyboardControl
            autoOk
            variant="inline"
            label="Εώς"
            margin='dense'
            id="date-picker-inline"
            format="dd/MM/yyyy"
            value={props.finalDate}
            onChange={props.handleDateChangeFinal}
            InputProps={{
              readOnly: true,
             }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </Grid>
        {props.search===true?<Grid item xs={12} sm={4}>
        <TextField id="standard-basic" label="Αναζήτηση"  onChange={props.handleChange}/>
        </Grid>:null}
        <Grid item xs={12} sm={3}>
          <Button style={{marginTop:'2vh'}}
            variant="contained"
            color="primary"
            onClick={props.datesSubmit}   
          >
            αναζητηση
        </Button>
        </Grid>
      </Grid>
    </MuiPickersUtilsProvider>
  );
}